module.exports = __webpack_public_path__ + "img/px7.png";